'use strict';

export default class Memory {
    constructor() {
        this.memory = new Array();
    }
    addToMemory(action, data) {
        let add = false;
        if(this.memory.length > 0) {
            const last = this.memory[this.memory.length-1];
            if(action !== last.action || data !== last.data) {
                add = true;
            }
        } else {
            add = true;
        }
        if (add) {
            this.memory.push({
                'action': action,
                'data': data
            });
        }
    }

}
